import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

import GoogleTranslateErrorBoundary from '@/components/ErrorBoundary/GoogleTranslateErrorBoundary';

import { merchantRoutes } from './merchant.routes';
import { ROUTES } from './paths';

const Root = lazy(() => import('@pages/Root'));
const Home = lazy(() => import('@pages/Home'));
const Mint = lazy(() => import('@pages/Mint/Mint'));
const Morfi = lazy(() => import('@pages/Morfi/index'));
const Error = lazy(() => import('@pages/Response/Error'));

export const router = createBrowserRouter([
  {
    path: ROUTES.HOME,
    element: (
      <GoogleTranslateErrorBoundary>
        <Root />
      </GoogleTranslateErrorBoundary>
    ),
    errorElement: <Error/>,
    children: [
      {
        element: (
          <GoogleTranslateErrorBoundary>
            <Home />
          </GoogleTranslateErrorBoundary>
        ),
        index: true,
      },
      {
        path: ROUTES.MINT,
        element: (
          <GoogleTranslateErrorBoundary>
            <Mint />
          </GoogleTranslateErrorBoundary>
        ),
      },
      {
        path: ROUTES.MORFI,
        element: (
          <GoogleTranslateErrorBoundary>
            <Morfi />
          </GoogleTranslateErrorBoundary>
        ),
      },
      merchantRoutes
    ],
  },
]); 